var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tag',{staticClass:"text-uppercase",attrs:{"type":_vm.getStatusItem(_vm.status).type,"size":"mini"}},[_vm._v("\n  "+_vm._s(_vm.$t(_vm.getStatusItem(_vm.status).translationKey))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }